import { Component } from '@angular/core';

@Component({
  selector: 'miq-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class LoaderComponent {}
